import type { RunStatusTone } from './get-run-status-tone'

/** Deferred, not applicable and skipped matching are not failures. */
export function getMatchStatusTone(status: string): RunStatusTone {
  if (status === 'completed') return 'success'
  if (status.startsWith('error') || status.startsWith('incomplete')) return 'failed'
  return 'skipped'
}
